import { render, staticRenderFns } from "./index.vue?vue&type=template&id=97d48e56"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=97d48e56&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97d48e56')) {
      api.createRecord('97d48e56', component.options)
    } else {
      api.reload('97d48e56', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=97d48e56", function () {
      api.rerender('97d48e56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SliderVerifyDialog/index.vue"
export default component.exports